import * as React from 'react'
import {ISelectedFeature} from '../../core/interfaces/reducers'
import {ISourceApplyEdits} from '../../core/interfaces/services'
import {Feature, FeatureStatus, Geometry, Polygon} from '../../core/models'
import {ServiceHub} from '../../core/ServiceHub'
import {IAppUser} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import EditFeatureDispatcherContainer from '../FeatureViews/EditFeatureDispatcherContainer'
import {ArchGeometryEditor} from '../FeatureViews/ArchPlan/ArchPlanHistoryEditor'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {IFeatureLayerInfo} from '../../core/interfaces/models'
import {IEditsDispatcher, IGeometryEditsDispatcher, IPopupDispatcher} from '../../core/interfaces/dispatchers'
import {getMapService} from '../../core/reducers/map'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {PlanHistoryStatus} from './ArchRegister'

interface Props {
  mobile: boolean
  mapComponent?: JSX.Element
  selected: boolean
  onBack: () => void
  onHistory: (feature: Feature) => void
  selectedPlan?: ISelectedFeature
  layerInfo: IFeatureLayerInfo
  user?: IAppUser
  geometryEditsDispatcher: IGeometryEditsDispatcher & IEditsDispatcher & IPopupDispatcher
}

interface State {
  afterSuccess: boolean
  loading: boolean
  errorMessage: string
  newPlanInnNumber?: number
}

export class ArchCreator extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      errorMessage: ''
    }
  }
  componentDidUpdate() {
    if (getMapService()) {
      getMapService().updateSize()
      setTimeout(() => {
        getMapService().updateSize()
        setTimeout(() => {
          getMapService().updateSize()
        }, 1000)
      }, 1000)
    }
  }
  getDetailView() {
    if (this.props.selectedPlan && this.props.selectedPlan.feature) {
      return (
        <div>
          <EditFeatureDispatcherContainer
            feature={this.props.selectedPlan.feature}
            layerId={appConfig.archImport.planHistory.url}
            hideCancel={true}
            hideDelete={true}
            hideSave={true}
            user={this.props.user}
            editAgain={f => {
              this.props.onBack()
              return f
            }}
          ></EditFeatureDispatcherContainer>
        </div>
      )
    }
  }
  protected save(feature: Feature): void {
    if (!feature.getGeometry() && this.props.user && this.props.user.isArchImportUser) {
      this.setState({...this.state, loading: false, errorMessage: 'Моля, попълнете или изчертайте геометрията'})
      return
    }
    this.setState({...this.state, loading: true, errorMessage: ''}, () => {
      let paylod: ISourceApplyEdits[] = [{layerInfo: this.props.layerInfo, adds: [], updates: [feature], deletes: []}]
      let isNew = false
      if (feature.status == FeatureStatus.New) {
        isNew = true
        paylod = [{layerInfo: this.props.layerInfo, adds: [feature], updates: [], deletes: []}]
      }
      this.props.geometryEditsDispatcher.applyEdits(
        paylod,
        edits => {
          this.props.layerInfo.refresh()
          ServiceHub.gisCrudService
            .execute(this.props.layerInfo, {
              where: `"Id" IN (${isNew ? edits[0].adds![0].getId() : feature.getId()})`
            })
            .then(r => {
              const status = r[0].get('ArchPlanHistoryStatusId')
              this.setState({
                ...this.state,
                afterSuccess: true,
                newPlanInnNumber: status == PlanHistoryStatus.Added ? r[0].get('ArchPlanId') : undefined,
                loading: false
              })
            })
            .catch(e => {
              this.setState({...this.state, afterSuccess: true, loading: false})
            })
        },
        e => {
          this.setState({...this.state, loading: false, errorMessage: 'Възникна грешка'})
        }
      )
    })
  }

  onGeometryChange = (feature: Feature, g?: Geometry) => {
    feature.setGeometry(g)
    if (this.props.geometryEditsDispatcher) {
      getMapService().editing.externalUpdate({
        [this.props.layerInfo.url]: {[this.props.selectedPlan!.feature.getId()]: feature}
      })
    }
  }

  getSaveBtnTitle() {
    let title = ''
    if (this.props.selectedPlan) {
      const status = this.props.selectedPlan.feature.get('ArchPlanHistoryStatusId')
      if (status == PlanHistoryStatus.Approved) {
        title = 'Одобри'
      }
      if (status == PlanHistoryStatus.Fixed) {
        title = 'Изпрати новата версия'
      }
      if (status == PlanHistoryStatus.Rejected) {
        title = 'Изпрати забележките'
      }
      if (status == PlanHistoryStatus.Added) {
        title = 'Изпрати проекта за преглед'
      }
    }
    return title
  }

  getGeometryStuff() {
    let holes = 0
    if (
      !this.props.mobile &&
      this.props.selectedPlan &&
      this.props.selectedPlan!.feature &&
      this.props.selectedPlan!.feature.getGeometry()
    ) {
      const geom = this.props.selectedPlan!.feature.getGeometry() as Polygon
      holes = geom.getCoordinates().length - 1
    }
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          maxHeight: this.props.user && this.props.user.isArchImportUser && !this.state.afterSuccess ? '100%' : '0',
          overflow: 'hidden',
          flexWrap: 'wrap'
        }}
      >
        {this.props.selectedPlan && this.props.layerInfo ? (
          <ArchGeometryEditor
            feature={this.props.selectedPlan!.feature}
            defaultDisplayCs={CoordinateSystem.BG2005CAD}
            showTransformSelector={true}
            geometryType={this.props.layerInfo.getGeometryType()}
            buttonsClassname={'button width'}
            onGeometryChange={g => {
              setTimeout(() => {
                getMapService().updateSize()
              }, 200)
              this.onGeometryChange(this.props.selectedPlan!.feature, g)
            }}
          />
        ) : null}
        {this.props.mapComponent ? (
          <div
            style={{
              height: `${370 + holes * 350}px`,
              minWidth: '300px',
              margin: '10px',
              flex: 1
            }}
          >
            {this.props.mapComponent}
          </div>
        ) : null}
      </div>
    )
  }
  protected getAttSize(feature: Feature) {
    let bytes = 0
    for (const key in feature.attachmentChanges.adds) {
      bytes += feature.attachmentChanges.adds[key].size || 0
    }
    for (const key in feature.attachmentChanges.updates) {
      bytes += feature.attachmentChanges.updates[key].size || 0
    }
    return bytes
  }
  isSizeAbove(feature: Feature) {
    return this.getAttSize(feature) > 120000000
  }
  isMainPdfMissing(feature: Feature) {
    let hasPlan = false
    for (const key in feature.attachmentChanges.adds) {
      if (key.indexOf('__MAIN_PDF__/') != -1) {
        hasPlan = true
      }
    }
    for (const key in feature.attachmentChanges.updates) {
      if (key.indexOf('__MAIN_PDF__/') != -1) {
        hasPlan = true
      }
    }
    return !hasPlan
  }
  isGeometryMissing(feature: Feature) {
    return !feature.getGeometry() || feature.getGeometry().getCoordinates().length == 0
  }
  protected isSaveDisabled(feature: Feature): boolean {
    if (this.props.user && this.props.user.isArchImportUser) {
      return this.isSizeAbove(feature) || this.isMainPdfMissing(feature) || this.isGeometryMissing(feature)
    }
    return this.isSizeAbove(feature)
  }

  getWarnings(feature: Feature) {
    const warnings: Array<JSX.Element> = []
    if (this.isSizeAbove(feature)) {
      warnings.push(
        <div key={1} className="warning-div">
          Максимален обем на прикачените файлове може да бъде 120 MB
        </div>
      )
    }
    if (this.props.user && this.props.user.isArchImportUser) {
      if (this.isMainPdfMissing(feature)) {
        warnings.push(
          <div key={2} className="warning-div">
            Моля, добавете PDF файл на проекта
          </div>
        )
      }
      if (this.isGeometryMissing(feature)) {
        warnings.push(
          <div key={3} className="warning-div">
            Моля, изчертайте обхват на проекта на картата
          </div>
        )
      }
    }

    return <div>{warnings}</div>
  }

  getSaveControls() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box'}}>
        {this.state.errorMessage ? <div className="error-div">{this.state.errorMessage}</div> : null}
        {!this.props.selectedPlan || !this.props.selectedPlan!.feature ? null : (
          <div>
            {this.getWarnings(this.props.selectedPlan!.feature)}
            <button
              type="button"
              style={{marginBottom: '20px'}}
              disabled={this.isSaveDisabled(this.props.selectedPlan!.feature)}
              className={'button width'}
              onClick={() => this.save(this.props.selectedPlan!.feature)}
            >
              {this.getSaveBtnTitle()}
            </button>
          </div>
        )}
      </div>
    )
  }
  getAfterSuccess(className: string, style: React.CSSProperties) {
    return (
      <div style={{height: '70%'}}>
        <div className="arch-success">
          <div className="success-div" style={{width: '280px'}}>
            Записът беше успешен
          </div>
          {this.state.newPlanInnNumber ? (
            <p>
              Вашият входящ номер е <b>{this.state.newPlanInnNumber}</b>
            </p>
          ) : null}
          <button
            type="button"
            style={{width: '300px'}}
            className="button"
            onClick={() => {
              this.setState({...this.state, afterSuccess: false, newPlanInnNumber: undefined}, () => {
                this.props.onBack()
              })
            }}
          >
            ОК
          </button>
        </div>
      </div>
    )
  }
  render() {
    const className =
      'arch-detail arch-panel' +
      (this.props.selected &&
      this.props.selectedPlan &&
      this.props.selectedPlan.id == appConfig.archImport.planHistory.url
        ? ''
        : ' closed')
    const style = {transform: this.props.selected ? 'translateX(-100%)' : ''}
    if (this.state.afterSuccess) {
    }

    return (
      <div className={className} style={style}>
        <span className="arch-panel-back" onClick={this.props.onBack}>
          <i className="fas fa-arrow-left" />
        </span>

        <OverlayLoader show={this.state.loading}></OverlayLoader>
        {this.state.afterSuccess ? this.getAfterSuccess(className, style) : null}
        {this.state.afterSuccess ? null : this.getDetailView()}
        {this.getGeometryStuff()}
        {this.state.afterSuccess ? null : this.getSaveControls()}
      </div>
    )
  }
}
